import FssaiLicenseContainer from "./containers";

export default FssaiLicenseContainer;
